var React = require('react');

function Flag (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.60267 1.45603L5.30933 2.91207H1.46667V7.28017H3.93067L4.224 5.82414H9.53333V1.45603H5.60267ZM4.4 0H11V12.3763H9.53333V7.28017H5.42667L5.13333 8.73621H0V1.45603H4.10667L4.4 0Z"}));
}

Flag.defaultProps = {"width":"11","height":"13","viewBox":"0 0 11 13"};

module.exports = Flag;

Flag.default = Flag;
